module.exports = __webpack_public_path__ + "static/react-static-emblem-80dd36d9d0151b55bcaed773ec53cfa4.png";